// import React, { useState, useEffect } from 'react';
// import { useAuth } from '../AuthContext/authContext';
// import { useNavigate } from 'react-router-dom';
// import './Login.css';


// const EyeIcon = () => (
//   <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
//     <circle cx="12" cy="12" r="3" />
//   </svg>
// );

// const EyeOffIcon = () => (
//   <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
//     <circle cx="12" cy="12" r="3" />
//     <line x1="2" y1="2" x2="22" y2="22" />
//   </svg>
// );

// const Login = () => {
//   console.log("ADMIN ENV:", process.env.REACT_APP_ADMIN_PASSWORD);
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [passwordShown, setPasswordShown] = useState(false);
//   const { user, login } = useAuth(); 
//   const navigate = useNavigate();
//   const [error, setError] = useState('');

//   useEffect(() => {
//     if (user) navigate('/video-hub');
//   }, [user, navigate]);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (login(username, password)) navigate('/video-hub');
//     else setError('Invalid username or password');
//   };

//   const togglePasswordVisibility = () => {
//     setPasswordShown(!passwordShown);
//   };

//   const goToHomepage = () => {
//     navigate('/');
//   };

//   return (
//     <div className="login-background">
//       <div className="login-container">
//         <h2>Login</h2>
//         {error && <p className="error">{error}</p>}
//         <form onSubmit={handleSubmit}>
//           <div>
//             <label>Username:</label>
//             <input
//               type="text"
//               value={username}
//               onChange={(e) => setUsername(e.target.value)}
//               required
//             />
//           </div>

//           <div>
//             <label>Password:</label>
//             <div className="password-field-wrapper">
//               <input
//                 type={passwordShown ? 'text' : 'password'}
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//               />
//               <span className="toggle-password-icon" onClick={togglePasswordVisibility}>
//                 {passwordShown ? <EyeOffIcon /> : <EyeIcon />}
//               </span>
//             </div>
//           </div>

//           <button type="submit">Login</button>
//           <button type="button" className="homepage-btn" onClick={goToHomepage}>Back to Homepage</button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;
import React, { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext/authContext';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const EyeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeOffIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
    <circle cx="12" cy="12" r="3" />
    <line x1="2" y1="2" x2="22" y2="22" />
  </svg>
);

const Login = () => {
  console.log("🔥 LOGIN COMPONENT RENDERED");
  console.log("🌍 ENV ADMIN:", process.env.REACT_APP_ADMIN_PASSWORD);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [passwordShown, setPasswordShown] = useState(false);
  const { user, login } = useAuth(); 
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    console.log("👤 CURRENT USER:", user);
    if (user) navigate('/video-hub');
  }, [user, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("🚀 LOGIN BUTTON CLICKED");
    console.log("Entered password:", password);
    console.log("ENV password:", process.env.REACT_APP_ADMIN_PASSWORD);

    const success = login(username, password);

    console.log("Login success?", success);

    if (success) navigate('/video-hub');
    else setError('Invalid username or password');
  };

  const togglePasswordVisibility = () => {
    setPasswordShown(!passwordShown);
  };

  const goToHomepage = () => {
    navigate('/');
  };

  return (
    <div className="login-background">
      <div className="login-container">
        <h2>Login</h2>
        {error && <p className="error">{error}</p>}

        <form onSubmit={handleSubmit}>
          <div>
            <label>Username:</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div>
            <label>Password:</label>
            <div className="password-field-wrapper">
              <input
                type={passwordShown ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <span className="toggle-password-icon" onClick={togglePasswordVisibility}>
                {passwordShown ? <EyeOffIcon /> : <EyeIcon />}
              </span>
            </div>
          </div>

          <button type="submit">Login</button>
          <button type="button" className="homepage-btn" onClick={goToHomepage}>
            Back to Homepage
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;